<template>
  <div class="dashboard__header">
    <div v-if="!dashboardHeader"
         class="spinner__medium--white d-flex justify-content-center">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-else class="row m-0 align-items-center dashboard__header--summary">
      <div class="col-md p-0">
        <h2>Welcome Back!</h2>
        <h1> {{ dashboardHeader.name }} </h1>
        <p>Customer ID: {{ dashboardHeader.id }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboardHeader',
  props: {
    dashboardHeader: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Header.vue